// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3uhyM","avatar":"style_avatar__4inpu","menuIcon":"style_menuIcon__3ZPeQ"};